// extracted by mini-css-extract-plugin
module.exports = {"ListItem":"styles_ListItem__3Gtxo","title":"styles_title__1YmCD","value":"styles_value__3ZvBg"};